import React from "react";
import styled from "@emotion/styled";

export enum ImageWithIconType {
  bad = "bad",
  good = "good",
}

interface ImageWithIconProps {
  type: ImageWithIconType;
}

const Root = styled.div<ImageWithIconProps>`
  position: relative;
  &:before {
    z-index: 1;
    width: 32px;
    height: 32px;
    content: "";
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%);
    background-image: ${(props) =>
      props.type === ImageWithIconType.bad
        ? 'url("/images/icons/bad.svg")'
        : 'url("/images/icons/good.svg")'};
  }
`;

const ImageWithIcon: React.FC<ImageWithIconProps> = ({ type, children }) => {
  return <Root type={type}>{children}</Root>;
};

export default ImageWithIcon;
